import script from "./NotificationPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationPanel.vue?vue&type=script&setup=true&lang=js"

import "./NotificationPanel.vue?vue&type=style&index=0&id=cfed66c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cfed66c2"]])

export default __exports__